import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft, ArrowRight } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { ASSET_MODAL_NEXT, ASSET_MODAL_NEXT_DISABLED, ASSET_MODAL_PREVIOUS, ASSET_MODAL_PREVIOUS_DISABLED } from "~/constants/testIDs";
export const PreviousAndNextAssetModalArrows = /*#__PURE__*/ memo((param)=>{
    let { onNextClick, onPreviousClick, className } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const hasPrevious = !!onPreviousClick;
    const hasNext = !!onNextClick;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("pointer-events-none flex w-full shrink-0 items-center justify-start bg-black p-1 md:fixed md:bottom-0 md:left-0 md:bg-transparent md:px-4 md:pb-3 md:pt-0", className),
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                disabled: !hasPrevious,
                size: isAboveMediumScreen ? "large" : "medium",
                onClick: onPreviousClick,
                className: "pointer-events-auto mr-auto disabled:bg-transparent disabled:text-grey-8",
                label: "Previous asset",
                "data-testid": hasPrevious ? ASSET_MODAL_PREVIOUS : ASSET_MODAL_PREVIOUS_DISABLED,
                children: /*#__PURE__*/ _jsx(ArrowLeft, {
                    className: "size-4 md:size-6"
                })
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                disabled: !hasNext,
                size: isAboveMediumScreen ? "large" : "medium",
                onClick: onNextClick,
                "data-testid": hasNext ? ASSET_MODAL_NEXT : ASSET_MODAL_NEXT_DISABLED,
                className: "pointer-events-auto ml-auto disabled:bg-transparent disabled:text-grey-8",
                label: "Next asset",
                children: /*#__PURE__*/ _jsx(ArrowRight, {
                    className: "size-4 md:size-6"
                })
            })
        ]
    });
});
PreviousAndNextAssetModalArrows.displayName = "PreviousAndNextAssetModalArrows";
